import html2canvas from "html2canvas";
import baseURLGlobal from '../../../utils/util';
const base_Url = baseURLGlobal;
export default baseURLGlobal;
export const SOURCE_HOME = "SOURCE_HOME";
export const SOURCE_WEBVIEW = "SOURCE_WEBVIEW";
export const GET = "GET";
export const POST = "POST";

// FUNCTION TO CAPTURE QUERY PARAMETERS, initialized by '?', separated by '&'
export const getQuery = () => {
  let b = window.location.search
    .slice(1)
    .split("&")
    .map((qStr) => qStr.split("="))
    .reduce((acc, inc) => {
      acc[inc[0]] = inc[1];
      return acc;
    }, {});
    // alert(b);
    // alert(b['token']);
  return b;
};



const token = getQuery()["token"] || localStorage.getItem("campaignToken");
localStorage.setItem("campaignToken",token);
// "eyJhbGciOiJIUzM4NCIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwib3JnSWQiOjEsInR5cGUiOjMsIm1vYmlsZSI6IjkxOTg3MTI1MTgwNSIsIm5hbWUiOiJzdHJpbmciLCJlbWFpbCI6InVzZXI5MUBleGFtcGxlLmNvbSIsImlhdCI6MTY1MjE2Mjc2MiwiZXhwIjoxNjUzODkwNzYyfQ.k2ihfzbgF924214u7sZ8cyN3bKOqubwGyzFGdsuHZ3dUhl83X-ITHaGOI1L9fzWw"
// "eyJhbGciOiJIUzM4NCIsInR5cCI6IkpXVCJ9.eyJpZCI6Mjg5OTk0LCJvcmdJZCI6MTcwLCJuYW1lIjoiR3VuamFuIEd1cHRhIiwiZW1haWwiOiJndW5qYW5AY2xhc3NwbHVzYXBwcC5jb20iLCJtb2JpbGUiOiI5MTk3MTExNTMwNzkiLCJ0eXBlIjozLCJpYXQiOjE2NDgxMjQ0NTksImV4cCI6MTY0ODcyOTI1OX0.Nf6pS8G74I3QD8RBkEpRkKKQOidnHeG-k0AZb0NR6zlp6ix5xNFr3YirQrTJEsZj"
// const token =
//   'eyJhbGciOiJIUzM4NCIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwib3JnSWQiOjEsIm5hbWUiOiJNYXN0ZXIgVHV0b3IiLCJlbWFpbCI6InNhazIyMkBnbWFpbC5jb20iLCJtb2JpbGUiOiI5MTk4NzEyNTE4MDUiLCJ0eXBlIjozLCJpYXQiOjE2Mjk3NTYxMzMsImV4cCI6MTYzMTQ4NDEzM30.ZAX1OBbWw8ICSOoYCZ3ggRqjrma448DIfx3cFQix5CWRzwueVC2jm7IOE5AhJ9NI';
// API CALL FUNCTION
export const makeApiCal = (action) => {

  // PARAMETERS - method, route, storeData, catchError, body
  switch (action.method) {
    case GET:
      return fetch(`${base_Url}/${action.route}`, {
        method: GET,
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
          Connection: "keep-alive",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          res?.status === "success"
            ? action.storeData(res?.data)
            : action.catchError(res.message);
        })
        .catch((err) => {
          action.catchError(err);
        });
    case POST:
      return fetch(`${base_Url}/${action.route}`, {
        method: POST,
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
          Connection: "keep-alive",
        },
        body: JSON.stringify(action.body),
      })
        .then((res) => res.json())
        .then((res) => {
          res?.status === "success"
            ? action.storeData(res?.data)
            : action.catchError(res.message);
        })
        .catch((err) => action.catchError(err));
    default:
      return;
  }
};

export const directDeepLink = (url, source, showAlert) => {
  const action = {
    method: POST,
    route: 'v2/storeDeeplink',
    body: { deeplink: url },
    storeData: (e) => console.log(e),
    catchError: (e) => console.error(e),
  };

  switch (source) {
    case SOURCE_HOME:
      // alert('1 - before api url'+ url)
      makeApiCal(action);
      let stringUrl = JSON.stringify(url);

      try {
        window?.webkit?.messageHandlers?.onDeeplinkExecutedV2?.postMessage(stringUrl);
      } catch(e) {
        // alert('webkit handler broken '+stringUrl)
      }

      try {
        window?.mobile?.exceuteDeeplink(stringUrl);
      } catch(e) {
        // alert('execute handler broken '+stringUrl)
      }

      try {
        window?.mobile?.onDeeplinkExecutedV2(stringUrl);
      } catch(e) {
        // alert('on deep link handler broken '+stringUrl)
      }
      break;

    case SOURCE_WEBVIEW:

      makeApiCal(action);
      window?.webkit?.messageHandlers?.onDeeplinkExecuted?.postMessage(
        `${url?.screen},${url?.paramOne},${url?.paramTwo},${url?.paramThree}`
      );

      // window?.mobile?.onDeeplinkExecuted(
      //   `${url?.screen},${url?.paramOne},${url?.paramTwo},${url?.paramThree}`
      // );

      window?.mobile?.onDeeplinkExecutedV2(JSON.stringify(url));

      break;
    default:
      return;
  }
};

export const utilWebView = (base64data, shareText) => {
  if (window?.mobile?.onDeeplinkExecuted) {
    window.mobile.onDeeplinkExecuted(`UTIL_SHARE_IMAGE_BASE64,${base64data}`);
    return;
  }

  if (window?.webkit?.messageHandlers?.onDeeplinkExecuted) {
    window.webkit.messageHandlers.onDeeplinkExecuted.postMessage(
        `UTIL_SHARE_IMAGE_BASE64,${base64data},${shareText}`
    );
  } else {
    const link = document.createElement("a");
    link.download = "Poster.png";
    link.href = base64data;
    link.target = "_blank";
    link.click();
  }
};

  
  export const utilTextShare = (textData) => {
    if (window && window.mobile && window.mobile.onDeeplinkExecuted) {
      window.mobile.onDeeplinkExecuted(`UTIL_SHARE,${textData}`);
  
      return;
    }
  
    if (
      window &&
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.onDeeplinkExecuted
    ) {
      window.webkit.messageHandlers.onDeeplinkExecuted.postMessage(
        `UTIL_SHARE,${textData}`
      );
    }
  };
  
  export const utilMakeBlob = (containerId, shareText) => {
    var container = document.getElementById(`${containerId}`);
  
    html2canvas(container, { allowTaint: true }).then(function (canvas) {
      canvas.toBlob((blob) => {
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
          var base64data = reader.result;
          base64data = btoa(base64data);
  
          return base64data;
        };
      });
    });
  };
  
  export const utilCopyShare = (containerId, shareText) => {
    var container = document.getElementById(`${containerId}`);
  
    html2canvas(container, { allowTaint: true }).then(function (canvas) {
      canvas.toBlob((blob) => {
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
          var base64data = reader.result;
          base64data = btoa(base64data);
  
          if (window && window.mobile && window.mobile.onDeeplinkExecuted) {
            window.mobile.onDeeplinkExecuted(
              `UTIL_SHARE_IMAGE_BASE64,${base64data}`
            );
  
            return;
          }
  
          if (
            window &&
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.onDeeplinkExecuted
          ) {
            window.webkit.messageHandlers.onDeeplinkExecuted.postMessage(
              `UTIL_SHARE_IMAGE_BASE64,${base64data},${shareText}`
            );
          } else {
            var link = document.createElement("a");
            document.body.appendChild(link);
            link.download = "Poster.png";
            link.href = base64data;
  
            link.target = "_blank";
            link.click();
          }
        };
      });
    });
  };
